<template lang="html">
  <a class="block" href="/">
    <img v-bind:src="logo" v-bind:alt="alt" class="m-2 w-16 mx-auto" />
  </a>
</template>

<script>
export default {
  data() {
    return {
      logo: require("@/assets/img/LogoPPmedium.png"),
      alt: "Push Poll"
    };
  }
};
</script>

<style lang="css"></style>
